module.exports = __webpack_public_path__ + "static/media/aleks.1645d236.jpeg";